//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      slide: 0,
      sliding: null,
      lastVideo: null,
      youtube: false,
      ytApiTag: null,
      ytPlayer: [],
      lastYT: null,
      lastYTindex: 0,
    };
  },
  props: {
    media: {
      type: Array,
      default: null,
    },
  },
  computed: {
    slideSet() {
      return this.media.map((item) => {
        if (item.type == "IMG") {
          return {
            type: "IMG",
            url: item.url,
          };
        } else {
          if (this.validateYoutubeURL(item.url)) {
            return { type: "YTV", url: this.validateYoutubeURL(item.url) };
          } else {
            return { type: "VID", url: item.url };
          }
        }
      });
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.slideSet[0].type == "VID") {
        this.$refs[`video${0}`][0].play();
        this.lastVideo = 0;
      }
      this.initiateYTapi();
    });
  },
  methods: {
    onSlideStart(slide) {
      if (this.slideSet[this.lastVideo].type == "VID") {
        this.$refs[`video${this.lastVideo}`][0].pause();
      }
      if (this.ytPlayer != []) {
        this.ytPlayer.pauseVideo();
        this.ytPlayer = null;
      }
    },
    onSlideEnd(slide) {
      if (this.slideSet[slide].type == "VID") {
        this.$refs[`video${slide}`][0].play();
        this.lastVideo = slide;
      } else if (this.slideSet[slide].type == "YTV") {
        this.initiateYTPlayer(slide, this.slideSet[slide].url);
        this.lastVideo = slide;
        if (this.ytPlayer == null) {
        }
      }
    },
    validateYoutubeURL(url) {
      var p = /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
      var matches = url.match(p);
      if (matches) {
        return matches[1];
      }
      return false;
    },
    initiateYTapi() {
      if (this.ytApiTag == null) {
        this.ytApiTag = document.createElement("script");
        this.ytApiTag.src = "https://www.youtube.com/iframe_api";
        var firstScriptTag = document.getElementsByTagName("script")[0];
        firstScriptTag.parentNode.insertBefore(this.ytApiTag, firstScriptTag);
      }
    },
    initiateYTPlayer(index, vId) {
      this.ytPlayer.push(
        new YT.Player(`youtubePlayer${index}`, {
          height: "390",
          width: "640",
          videoId: vId,
          events: {
            onReady: this.onPlayerReady,
            //'onStateChange': onPlayerStateChange
          },
        })
      );
      this.lastYTindex = this.ytPlayer.length - 1;
    },
    onPlayerReady(event) {
      this.lastYT = event.target;
      this.lastYT.playVideo();
      //this.lastVideo = index;
    },
  },
};
